import qs, { IStringifyOptions } from 'qs';

export type QueryParameters = {
  [key: string]: string | string[];
};

// parses a query string, allows only strings and arrays, doesn't allow objects like a[b]=d
export const parseQueryString = (queryString: string): QueryParameters =>
  qs.parse(queryString, { ignoreQueryPrefix: true, depth: 0 }) as QueryParameters;

// generates a query string, arrays are formatted like ?a=b&a=c
export const generateQueryString = (params: QueryParameters, options?: IStringifyOptions) =>
  qs.stringify(params, { arrayFormat: 'repeat', ...options });
